import { useContext } from "react";
import { AuthContext, type AuthContextValue, type PersistedSession } from "./authContext";

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside AuthProvider");
  }
  return ctx;
}

export function useSession(): PersistedSession {
  const { state } = useAuth();
  if (state.status !== "authenticated") {
    throw new Error("useSession called outside RequireAuth");
  }
  return state.session;
}
